module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-dizzy-0a7b62ff.svg";